/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiEnrolmentByExternalIdExternalIdGet } from '../fn/enrolment/api-enrolment-by-external-id-external-id-get';
import { ApiEnrolmentByExternalIdExternalIdGet$Params } from '../fn/enrolment/api-enrolment-by-external-id-external-id-get';
import { apiEnrolmentEnrolmentIdMerchantGet } from '../fn/enrolment/api-enrolment-enrolment-id-merchant-get';
import { ApiEnrolmentEnrolmentIdMerchantGet$Params } from '../fn/enrolment/api-enrolment-enrolment-id-merchant-get';
import { apiEnrolmentEnrolmentIdProgressReportGet } from '../fn/enrolment/api-enrolment-enrolment-id-progress-report-get';
import { ApiEnrolmentEnrolmentIdProgressReportGet$Params } from '../fn/enrolment/api-enrolment-enrolment-id-progress-report-get';
import { apiEnrolmentFillEnrolmentsMissingInstitutionsPost } from '../fn/enrolment/api-enrolment-fill-enrolments-missing-institutions-post';
import { ApiEnrolmentFillEnrolmentsMissingInstitutionsPost$Params } from '../fn/enrolment/api-enrolment-fill-enrolments-missing-institutions-post';
import { apiEnrolmentSyncMasterclassPost } from '../fn/enrolment/api-enrolment-sync-masterclass-post';
import { ApiEnrolmentSyncMasterclassPost$Params } from '../fn/enrolment/api-enrolment-sync-masterclass-post';
import { apiEnrolmentSyncOldPost } from '../fn/enrolment/api-enrolment-sync-old-post';
import { ApiEnrolmentSyncOldPost$Params } from '../fn/enrolment/api-enrolment-sync-old-post';
import { apiEnrolmentSyncPost } from '../fn/enrolment/api-enrolment-sync-post';
import { ApiEnrolmentSyncPost$Params } from '../fn/enrolment/api-enrolment-sync-post';
import { Enrolment } from '../models/enrolment';
import { Error } from '../models/error';
import { ImportResult } from '../models/import-result';
import { MerchantList } from '../models/merchant-list';
import { StudentProgressReport } from '../models/student-progress-report';


/**
 * Enrolment service
 */
@Injectable({ providedIn: 'root' })
export class EnrolmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiEnrolmentEnrolmentIdProgressReportGet()` */
  static readonly ApiEnrolmentEnrolmentIdProgressReportGetPath = '/api/enrolment/{enrolment_id}/progress-report';

  /**
   * Get a student's progress report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentEnrolmentIdProgressReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentEnrolmentIdProgressReportGet$Response(params: ApiEnrolmentEnrolmentIdProgressReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProgressReport>> {
    return apiEnrolmentEnrolmentIdProgressReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a student's progress report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentEnrolmentIdProgressReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentEnrolmentIdProgressReportGet(params: ApiEnrolmentEnrolmentIdProgressReportGet$Params, context?: HttpContext): Observable<StudentProgressReport> {
    return this.apiEnrolmentEnrolmentIdProgressReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StudentProgressReport>): StudentProgressReport => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentEnrolmentIdMerchantGet()` */
  static readonly ApiEnrolmentEnrolmentIdMerchantGetPath = '/api/enrolment/{enrolment_id}/merchant';

  /**
   * Get the merchants associated with an enrolment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentEnrolmentIdMerchantGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentEnrolmentIdMerchantGet$Response(params: ApiEnrolmentEnrolmentIdMerchantGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantList>> {
    return apiEnrolmentEnrolmentIdMerchantGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the merchants associated with an enrolment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentEnrolmentIdMerchantGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentEnrolmentIdMerchantGet(params: ApiEnrolmentEnrolmentIdMerchantGet$Params, context?: HttpContext): Observable<MerchantList> {
    return this.apiEnrolmentEnrolmentIdMerchantGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MerchantList>): MerchantList => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentSyncPost()` */
  static readonly ApiEnrolmentSyncPostPath = '/api/enrolment/sync';

  /**
   * Sync enrolments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncPost$Response(params: ApiEnrolmentSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiEnrolmentSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync enrolments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncPost(params: ApiEnrolmentSyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiEnrolmentSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentSyncOldPost()` */
  static readonly ApiEnrolmentSyncOldPostPath = '/api/enrolment/sync-old';

  /**
   * Sync enrolments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentSyncOldPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncOldPost$Response(params: ApiEnrolmentSyncOldPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiEnrolmentSyncOldPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync enrolments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentSyncOldPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncOldPost(params: ApiEnrolmentSyncOldPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiEnrolmentSyncOldPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentSyncMasterclassPost()` */
  static readonly ApiEnrolmentSyncMasterclassPostPath = '/api/enrolment/sync-masterclass';

  /**
   * Sync masterclass enrolment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentSyncMasterclassPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncMasterclassPost$Response(params: ApiEnrolmentSyncMasterclassPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiEnrolmentSyncMasterclassPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync masterclass enrolment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentSyncMasterclassPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiEnrolmentSyncMasterclassPost(params: ApiEnrolmentSyncMasterclassPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiEnrolmentSyncMasterclassPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentFillEnrolmentsMissingInstitutionsPost()` */
  static readonly ApiEnrolmentFillEnrolmentsMissingInstitutionsPostPath = '/api/enrolment/fill-enrolments-missing-institutions';

  /**
   * Fill enrolments with missing institutions from a CSV file.
   * Returns a JSON file with the import results.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentFillEnrolmentsMissingInstitutionsPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiEnrolmentFillEnrolmentsMissingInstitutionsPost$Response(params: ApiEnrolmentFillEnrolmentsMissingInstitutionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
    return apiEnrolmentFillEnrolmentsMissingInstitutionsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Fill enrolments with missing institutions from a CSV file.
   * Returns a JSON file with the import results.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentFillEnrolmentsMissingInstitutionsPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiEnrolmentFillEnrolmentsMissingInstitutionsPost(params: ApiEnrolmentFillEnrolmentsMissingInstitutionsPost$Params, context?: HttpContext): Observable<Error> {
    return this.apiEnrolmentFillEnrolmentsMissingInstitutionsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Error>): Error => r.body)
    );
  }

  /** Path part for operation `apiEnrolmentByExternalIdExternalIdGet()` */
  static readonly ApiEnrolmentByExternalIdExternalIdGetPath = '/api/enrolment/by-external-id/{external_id}';

  /**
   * Get an enrolment by external_id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEnrolmentByExternalIdExternalIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentByExternalIdExternalIdGet$Response(params: ApiEnrolmentByExternalIdExternalIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Enrolment>> {
    return apiEnrolmentByExternalIdExternalIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an enrolment by external_id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEnrolmentByExternalIdExternalIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEnrolmentByExternalIdExternalIdGet(params: ApiEnrolmentByExternalIdExternalIdGet$Params, context?: HttpContext): Observable<Enrolment> {
    return this.apiEnrolmentByExternalIdExternalIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Enrolment>): Enrolment => r.body)
    );
  }

}
